import ContentLayout from '../../layout/ContentLayout';
import styles from '../../styles/reportsAndStatistics.module.scss';
import StatisticCard from './statisticCard';
import StatisticChart from './statisticChart';
import PieGraph from './pieGraph';

const ReportsAndStatistics = () => {
  const data = [
    {
      id: 1,
      title: 'Dnevna aktivnost',
      value: '21 kupovina',
      change: '40',
      period: 'manje nego prethodni dan',
      type: 'down',
    },
    {
      id: 2,
      title: 'Nedeljna aktivnost',
      value: '64 kupovine',
      change: '50',
      period: 'više nego prošle nedelje',
      type: 'up',
    },
    {
      id: 3,
      title: 'Mesečna aktivnost',
      value: '105 kupovina',
      change: '50',
      period: 'više nego prošli mesec',
      type: 'up',
    },
  ];

  const statisticPerMonth = [
    { month: 'Jan', purchased: 4000, vouchers: 2400 },
    { month: 'Feb', purchased: 3000, vouchers: 1398 },
    { month: 'Mar', purchased: 2000, vouchers: 800 },
    { month: 'Apr', purchased: 2780, vouchers: 1908 },
    { month: 'Maj', purchased: 1890, vouchers: 800 },
    { month: 'Jun', purchased: 2390, vouchers: 1800 },
    { month: 'Jul', purchased: 3490, vouchers: 2300 },
    { month: 'Avg', purchased: 3000, vouchers: 1398 },
    { month: 'Sep', purchased: 2000, vouchers: 800 },
    { month: 'Okt', purchased: 2780, vouchers: 1908 },
    { month: 'Nov', purchased: 1890, vouchers: 800 },
    { month: 'Dec', purchased: 2390, vouchers: 800 },
  ];

  const pieData = {
    items: [
      { name: 'VIP korisnici', value: 56 },
      { name: 'Ukupni korisnici', value: 98 },
    ],
    colors: ['#E1E4ED', '#005844'],
    label: 56,
  };

  const pieData2 = {
    items: [
      { name: 'VIP korisnici', value: 56 },
      { name: 'Ukupni korisnici sa poenima', value: 25 },
      { name: 'Ukupni korisnici', value: 98 },
    ],
    colors: ['#E1E4ED', '#B8D9BC', '#005844'],
    label: '72%',
  };

  return (
    <>
      <ContentLayout pt={true}>
        <div className={styles.report}>
          <div className={styles.report__header}>Izveštaji i statistika</div>
          {/*aktivnost korisnika*/}
          <div className={styles.report__activity}>
            <p>Aktivnost korisnika</p>
            <div className={styles.report__activity__grid}>
              {data.map((item) => (
                <StatisticCard key={item.id} data={item} />
              ))}
            </div>
          </div>
          {/*aktivnost korisnika*/}
          {/*prodaja proizvoda i vaučera*/}
          <div className={styles.report__activity}>
            <p>Prodaja proizvoda i vaučera</p>
            <StatisticChart data={statisticPerMonth} />
          </div>
          {/*prodaja proizvoda i vaučera*/}
          {/*vip - poeni i nagrade*/}
          <div className={styles.points}>
            {/*vip*/}
            <div className={styles.points__wrap}>
              <h4>VIP članstvo</h4>
              <div className={styles.points__wrap__item}>
                <div className={styles.points__wrap__item__chart}>
                  <PieGraph data={pieData} />
                </div>
                <div className={styles.points__wrap__item__desc}>
                  <div className={styles.points__wrap__item__desc__item}>
                    <div
                      className={`${styles.points__wrap__item__desc__item__dot} ${styles['points__wrap__item__desc__item__dot--gray']}`}
                    ></div>
                    <p>
                      Broj ukupnih korisnika: <span>98</span>
                    </p>
                  </div>
                  <div className={styles.points__wrap__item__desc__item}>
                    <div
                      className={`${styles.points__wrap__item__desc__item__dot} ${styles['points__wrap__item__desc__item__dot--green']}`}
                    ></div>
                    <p>
                      Broj VIP korisnika: <span>56</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/*vip*/}
            {/*poeni i nagrade*/}
            <div className={styles.points__wrap}>
              <h4>Poeni i nagrade</h4>
              <div className={styles.points__wrap__item}>
                <div className={styles.points__wrap__item__chart}>
                  <PieGraph data={pieData2} />
                </div>
                <div className={styles.points__wrap__item__desc}>
                  <h5>
                    Iskorišćenost poena i nagrada: <span>72%</span>
                  </h5>
                  <div className={styles.points__wrap__item__desc__item}>
                    <div
                      className={`${styles.points__wrap__item__desc__item__dot} ${styles['points__wrap__item__desc__item__dot--gray']}`}
                    ></div>
                    <p>
                      Broj ukupnih korisnika: <span>98</span>
                    </p>
                  </div>
                  <div className={styles.points__wrap__item__desc__item}>
                    <div
                      className={`${styles.points__wrap__item__desc__item__dot} ${styles['points__wrap__item__desc__item__dot--light-green']}`}
                    ></div>
                    <p>
                      Broj kosinika sa poenima: <span>74</span>
                    </p>
                  </div>
                  <div className={styles.points__wrap__item__desc__item}>
                    <div
                      className={`${styles.points__wrap__item__desc__item__dot} ${styles['points__wrap__item__desc__item__dot--green']}`}
                    ></div>
                    <p>
                      Broj kosinika koji koriste vaučere i poene:
                      <span>56</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/*poeni i nagrade*/}
          </div>
          {/*vip - poeni i nagrade*/}
        </div>
      </ContentLayout>
    </>
  );
};
export default ReportsAndStatistics;
